import React, { useState, useRef, useEffect } from 'react'
import Button from '@mui/material/Button';
import api from "../../controller/api"
import { toast, Toaster } from 'sonner';
import { BiLoader } from "react-icons/bi"
import { useNavigate } from "react-router-dom"
import { createStore } from '../../store/state';
import { setAuthToken } from '../../controller/api';

export default function CategoryAdd() {
    const [categoryName, setCategoryName] = useState("")
    const [file, setFile] = useState(null)
    const [loading, setLoading] = useState(false)

    const inputFile = useRef(null);
    const navigate = useNavigate()

    const getFiles = (e) => {
        setFile(e.target.files[0]);
    }

    const handleAdd = async () => {
        setLoading(true)

        const formData = new FormData();
        formData.append("file", file);
        formData.append("categoryName", categoryName);

        try {
            await api.post("/category/create", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            toast.success("Category added")
            setCategoryName("")
            inputFile.current.value = "";
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='manage'>
            <h2 style={{ display: "flex", justifyContent: "space-between" }}>
                Category Add
                <Button variant="contained" onClick={() => navigate("/dashboard/category")}>Back to List</Button>
            </h2>
            <div className='add-product'>
                <Toaster richColors position="top-center" />
                <div className='form-row'>
                    <div className='inpt-row'>
                        <label>Category Name</label>
                        <input type='text' value={categoryName} onChange={(e) => setCategoryName(e.target.value)} required />
                    </div>
                </div>
                <div className='form-row'>
                    <div className='inpt-row'>
                        <label>Upload Image</label>
                        <input type='file' onChange={getFiles} ref={inputFile} required />
                    </div>
                </div>
                <Button type='submit' variant="contained" disableElevation onClick={handleAdd}>
                    {loading ? <BiLoader size={24} className='animate-spin' /> : "Add Category"}
                </Button>
            </div>
        </div>

    )
}
